module.exports = __webpack_public_path__ + "media/images/SS_logo-6a77f9fafb984dcdc43a6f8394e9271f.png";